import CircularProgress from '@material-ui/core/CircularProgress';
import { SwitchInput, DropdownInput } from '@trueprodigy/components';
import TextInput from '@components/TextInputCaseSetting';
import moment from 'moment';
import { isEqual, get } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { compose } from 'redux';
import { reduxForm, Field } from 'redux-form/immutable';
import styled from 'styled-components';
import { AppBar, Tab, Tabs } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Clear';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import { showSuccess, showError } from '@actions/global';
import { fetchingState } from '@constants';
import { canEditSubject } from '@config/permissions/Can';

import * as ownerActions from '../../actions/owner';
import * as propertyActions from '@modules/appraisal/actions/property';
import selector from './selector';
import TabPanel from '@components/TabPanel';
import OwnerEvents from '../ownerEvents';
import OwnerRevisionHistory from '../ownerRevisionHistory';
import OwnerTags from '../ownerTags';
import OwnerAliasNames from '../ownerAliasNames';
import SubjectDetailHeader from '../../components/subjectDetailForm/subjectDetailHeader';
import PhoneNumbers from './phoneNumbers';
import {
  Container,
  SubjectDetailFormContainer,
  FieldColumn,
  InfoBlock,
  FormGroupTitleContainer,
  FormGroupTitle,
  CalendarInputContainer,
  StyledButton,
} from '../../components/subjectDetailForm/formComponents';
import SubjectComments from '../../components/subjectDetailForm/subjectComments';
import SubjectProperties from '../../components/subjectDetailForm/subjectProperties';
import OwnerGroup from './ownerGroup';
import { withStyles } from '@material-ui/core/styles';
import { ownerLookupModes } from '@modules/appraisal/constants';

const styles = {
  rootStyle: {
    borderRadius: 20,
  },
  appBar: {
    color: 'rgba(0, 0, 0, 0.6)',
    fontWeight: 500,
    backgroundColor: '#efefef',
    boxShadow: 'none',
    '& .MuiTabs-indicator': {
      backgroundColor: '#384698',
    },
    '& .MuiTab-wrapper': {
      letterSpacing: '1.25px',
    },
    '& .Mui-selected': {
      color: '#384698',
    },
  },
};
import './index.scss';

class OwnerDetail extends Component {
  static propTypes = {
    addOwnerNote: PropTypes.func.isRequired,
    addOrCreateOwnerGroup: PropTypes.func.isRequired,
    classes: PropTypes.object,
    createOwner: PropTypes.func.isRequired,
    deleteOwnerNote: PropTypes.func.isRequired,
    deleteOwnerGroup: PropTypes.func.isRequired,
    dirty: PropTypes.bool,
    dropdowns: ImmutablePropTypes.map,
    fetchOwner: PropTypes.func.isRequired,
    fetchPropertyOwnerNames: PropTypes.func.isRequired,
    fetchOwnerNotes: PropTypes.func.isRequired,
    fetchOwnerProperties: PropTypes.func.isRequired,
    fetchPropertyDropdowns: PropTypes.func.isRequired,
    fetchOwnerGroups: PropTypes.func.isRequired,
    formValues: PropTypes.any,
    handleSubmit: PropTypes.func.isRequired,
    history: PropTypes.object,
    initialize: PropTypes.func.isRequired,
    match: PropTypes.object,
    notes: PropTypes.object,
    openOwnerLookupModal: PropTypes.func.isRequired,
    owner: ImmutablePropTypes.map,
    ownerGroups: ImmutablePropTypes.map,
    ownerId: PropTypes.number,
    ownerValidate: PropTypes.object,
    properties: PropTypes.object,
    property: ImmutablePropTypes.map,
    reset: PropTypes.func.isRequired,
    resetOwnerData: PropTypes.func.isRequired,
    resetOwnerModalSelection: PropTypes.func.isRequired,
    resetOwnerGroups: PropTypes.func.isRequired,
    selectedOwner: PropTypes.any,
    setPrimaryOwnerGroup: PropTypes.func.isRequired,
    showSuccess: PropTypes.func.isRequired,
    showError: PropTypes.func.isRequired,
    updateOwner: PropTypes.func.isRequired,
    updateOwnerNote: PropTypes.func.isRequired,
    validateOwner: PropTypes.func.isRequired,
    validateOwnerAddress: PropTypes.func.isRequired,
    embeddedView: PropTypes.bool,
    isEditable: PropTypes.number,
    isReadOnly: PropTypes.any,
    isPropertyEditable: PropTypes.number,
    fetchPropertyOwners: PropTypes.func.isRequired,
    viewOnly: PropTypes.any,
  };

  constructor(props) {
    super(props);
    const { match, resetOwnerData, ownerId } = this.props;
    this.isNew = !get(match, 'params.ownerId') && !ownerId;
    this.state = {
      note: '',
      isNew: this.isNew,
      ownerId: Number(get(match, 'params.ownerId')) || Number(ownerId),
      addressConfirmDialogOpen: false,
      value: 0,
      ownerGroupID: null,
    };

    if (this.isNew) {
      resetOwnerData();
    }
  }

  componentDidMount() {
    const { fetchPropertyDropdowns, initialize } = this.props;
    const { isNew, ownerId } = this.state;
    if (!isNew) {
      this.loadOwnerData(ownerId);
    }
    if (isNew) {
      initialize({ addrCountry: 'US' });
    }
    fetchPropertyDropdowns({
      fieldName: 'addrCountry',
      endpoint: '/appraisal/codes?type=Address&name=Country',
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.ownerValidate.toJS().state === 'saving' &&
      this.props.ownerValidate.toJS().state === 'loaded'
    ) {
      const { formValues, showError } = this.props;
      if (this.props.ownerValidate.toJS().data) {
        let oldAddress = formValues
          ? `${formValues.get('values').toJS().addrDeliveryLine} ${
              formValues.get('values').toJS().addrCity
            } ${formValues.get('values').toJS().addrState}, ${
              formValues.get('values').toJS().addrZip
            }`
          : '';
        let newAddress = `${
          this.props.ownerValidate.toJS().data.addrDeliveryLine
        } ${this.props.ownerValidate.toJS().data.addrCity} ${
          this.props.ownerValidate.toJS().data.addrState
        }, ${this.props.ownerValidate.toJS().data.addrZip}`;
        if (newAddress !== oldAddress) {
          this.setState({ addressConfirmDialogOpen: true });
        } else {
          this.onSave();
        }
      } else {
        showError('Address could not be validated');
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      owner,
      initialize,
      match,
      resetOwnerData,
      embeddedView,
      ownerValidate,
      resetOwnerGroups,
    } = this.props;
    if (
      !isEqual(owner, nextProps.owner) &&
      nextProps.owner.get('data') &&
      nextProps.owner.get('data') !== owner.get('data') &&
      !(
        ownerValidate.toJS().state === 'saving' &&
        nextProps.ownerValidate.toJS().state === 'loaded'
      )
    ) {
      const data = nextProps.owner.get('data').toJS();
      if (data.spouseBirthDt) {
        data.spouseBirthDt = moment(data.spouseBirthDt).format(
          'YYYY-MM-DDThh:mm',
        );
      }
      if (data.birthDt) {
        data.birthDt = moment(data.birthDt).format('YYYY-MM-DDThh:mm');
      }
      data.autoCass = data.autoCass || false;

      initialize({
        ...data,
      });
      if (data.ownerGroupID !== null) {
        this.setState({ ownerGroupID: data.ownerGroupID });
        this.loadOwnerGroup(data.ownerGroupID);
      } else {
        resetOwnerGroups();
      }
    } else if (
      !isEqual(owner, nextProps.owner) &&
      !nextProps.owner.get('data')
    ) {
      // initialize({});
    }
    if (!embeddedView && !owner.get('data') && nextProps.owner.get('data')) {
      this.setState({
        isNew: false,
        ownerId: nextProps.owner.getIn(['data', 'ownerID']),
      });
    }
    if (
      get(match, 'params.ownerId') !== get(nextProps, 'match.params.ownerId')
    ) {
      if (!get(nextProps, 'match.params.ownerId')) {
        this.setState({ isNew: true });
        resetOwnerData();
        initialize({ addrCountry: 'US' });
      }
    }
  }

  loadOwnerData(ownerId) {
    const { fetchOwner, fetchOwnerNotes, fetchOwnerProperties } = this.props;
    fetchOwner({
      ownerId,
    });
    fetchOwnerNotes({
      ownerId,
    });
    fetchOwnerProperties({
      ownerId,
    });
  }

  loadOwnerGroup(ownerGroupID) {
    if (ownerGroupID === null || ownerGroupID === undefined) {
      return;
    }
    const { fetchOwnerGroups } = this.props;
    fetchOwnerGroups({ ownerGroupID });
  }

  redirectTo(link) {
    const { history } = this.props;
    history.push(link);
  }

  async validate() {
    const { formValues, validateOwnerAddress } = this.props;
    if (!formValues) {
      return;
    }
    const formData = formValues.get('values').toJS();
    validateOwnerAddress({
      data: {
        ...formData,
        autoCass: 1,
        createDt: undefined,
        createdBy: undefined,
        updateDt: undefined,
        updatedBy: undefined,
        ownerID: undefined,
        lastUpdate: this.props.owner.toJS().data
          ? this.props.owner.toJS().data.updateDt
          : formData.updateDt,
      },
    });
  }

  async onDecline() {
    const {
      formValues,
      updateOwner,
      createOwner,
      showSuccess,
      fetchOwnerNotes,
      fetchOwnerProperties,
    } = this.props;
    const { isNew, ownerId } = this.state;
    if (!formValues) {
      return;
    }
    const formData = formValues.get('values').toJS();
    if (isNew) {
      const { results } = await createOwner({
        data: {
          ...formData,
          autoCass: false,
          createDt: undefined,
          createdBy: undefined,
          updateDt: undefined,
          updatedBy: undefined,
          ownerID: undefined,
          lastUpdate: formData.updateDt,
        },
      });
      fetchOwnerNotes({
        ownerId: results[0].ownerID,
      });
      fetchOwnerProperties({
        ownerId: results[0].ownerID,
      });
      showSuccess('Owner created');
    } else {
      await updateOwner({
        ownerId,
        data: {
          ...formData,
          autoCass: false,
          createDt: undefined,
          createdBy: undefined,
          updateDt: undefined,
          updatedBy: undefined,
          ownerID: undefined,
          lastUpdate: formData.updateDt,
        },
      });
    }
  }

  async onSave() {
    const {
      formValues,
      updateOwner,
      createOwner,
      showSuccess,
      fetchOwnerNotes,
      fetchOwnerProperties,
      fetchPropertyOwners,
      fetchPropertyOwnerNames,
      property,
    } = this.props;
    const { isNew, ownerId } = this.state;
    if (!formValues) {
      return;
    }
    const formData = formValues.get('values').toJS();
    if (isNew) {
      const { results } = await createOwner({
        data: {
          ...formData,
          createDt: undefined,
          createdBy: undefined,
          updateDt: undefined,
          updatedBy: undefined,
          ownerID: undefined,
          lastUpdate: formData.updateDt,
        },
      });
      fetchOwnerNotes({
        ownerId: results[0].ownerID,
      });
      fetchOwnerProperties({
        ownerId: results[0].ownerID,
      });
      showSuccess('Owner created');
    } else {
      await updateOwner({
        ownerId,
        data: {
          ...formData,
          createDt: undefined,
          createdBy: undefined,
          updateDt: undefined,
          updatedBy: undefined,
          ownerID: undefined,
          lastUpdate: formData.updateDt,
        },
      });
      if (
        property.getIn(['data', 'pid']) &&
        property.getIn(['data', 'pYear'])
      ) {
        fetchPropertyOwners({
          propertyId: property.getIn(['data', 'pid']),
          pYear: property.getIn(['data', 'pYear']),
          pVersion: property.getIn(['data', 'pVersion']),
          pRollCorr: property.getIn(['data', 'pRollCorr']),
        });
        fetchPropertyOwnerNames({
          propertyId: property.getIn(['data', 'pid']),
          selectedYear: property.getIn(['data', 'pYear']),
          pVersion: property.getIn(['data', 'pVersion']),
          pRollCorr: property.getIn(['data', 'pRollCorr']),
        });
      }
    }
  }

  async onAddOwnerGroup(newOwnerID) {
    const { addOrCreateOwnerGroup, ownerId, match } = this.props;
    const { ownerGroupID } = this.state;
    const ownerID = Number(get(match, 'params.ownerId')) || Number(ownerId);
    try {
      const res = await addOrCreateOwnerGroup({
        payload: {
          firstOwnerID: ownerID,
          secondOwnerID: newOwnerID,
        },
      });
      if (res && res.results) {
        this.loadOwnerGroup(res.results[0].ownerGroupID);
        if (ownerGroupID === null) {
          this.setState({
            ownerGroupID: res.results[0].ownerGroupID,
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  async onDeleteOwnerGroup(ownerID) {
    const { deleteOwnerGroup } = this.props;
    const { ownerGroupID } = this.state;
    await deleteOwnerGroup({ ownerGroupID, ownerID });
    this.loadOwnerGroup(ownerGroupID);
  }

  async onSetPrimaryOwnerGroup(payload) {
    const { setPrimaryOwnerGroup } = this.props;
    const { ownerGroupID } = this.state;
    await setPrimaryOwnerGroup({ ownerGroupID, payload });
    this.loadOwnerGroup(ownerGroupID);
  }

  onOpenOwnerModal() {
    const { openOwnerLookupModal } = this.props;
    openOwnerLookupModal(ownerLookupModes.singleSelection);
  }

  render() {
    const {
      history,
      owner,
      notes,
      properties,
      formValues,
      addOwnerNote,
      deleteOwnerNote, // dirty,
      updateOwnerNote,
      embeddedView,
      classes,
      match,
      property,
      dropdowns,
      ownerGroups,
      selectedOwner,
      resetOwnerModalSelection,
      viewOnly,
    } = this.props;

    const { ownerId, isNew, value } = this.state;
    const isEditable = canEditSubject('AppraisalOwner'); // && isPropertyEditable;
    const certified =
      property.getIn(['data', 'rollCorrGroupStatus']) === 'Certified';

    const isReadOnly = this.props.isReadOnly || viewOnly;

    return (
      <Container>
        {match.params.ownerId && (
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            style={{ padding: '7px 10px', backgroundColor: '#efefef' }}
          >
            <Link
              onClick={() => {
                history.push('/appraisal/owner/search');
              }}
            >
              Owner List
            </Link>
            <Typography color="textPrimary">{ownerId}</Typography>
          </Breadcrumbs>
        )}
        {(isNew ||
          (owner.get('state') &&
            owner.get('state') !== fetchingState.FETCHING)) && (
          <SubjectDetailHeader
            embeddedView={embeddedView}
            isNew={isNew}
            name={owner.getIn(['data', 'name'])}
            subjectId={ownerId}
            subjectType="Owner"
            onClose={() => this.redirectTo('/appraisal/owner/search')}
          />
        )}
        {!isNew && (
          <AppBar className={classes.appBar} position="static">
            <Tabs
              value={value}
              onChange={(_, v) => this.setState({ value: v })}
            >
              <Tab label="GENERAL" />
              <Tab label="EVENTS" />
              <Tab label="REVISION HISTORY" />
              <Tab label="OWNER TAGS" />
              <Tab label="ALIAS NAMES" />
            </Tabs>
          </AppBar>
        )}
        <TabPanel value={value} index={0}>
          {!isNew && owner.get('state') === fetchingState.FETCHING && (
            <CircularProgress />
          )}
          {(isNew ||
            (owner.get('state') &&
              owner.get('state') !== fetchingState.FETCHING)) && (
            <Fragment>
              <div style={{ padding: '20px 20px 0 20px' }}>
                <Field
                  component={TextInput}
                  disabled={certified || isReadOnly}
                  label="Name"
                  name="name"
                  placeholder="Name"
                  type="text"
                />
              </div>
              <SubjectDetailFormContainer>
                <FieldColumn padding="0px 20px 0px 20px" width="50%">
                  <Field
                    component={TextInput}
                    disabled={certified || isReadOnly}
                    label="Secondary Name(i.e. Etux, Eta, c/o)"
                    name="nameSecondary"
                    placeholder="Secondary Name(i.e. Etux, Eta, c/o)"
                    type="text"
                  />
                  <div style={{ display: 'flex' }}>
                    <Field
                      component={SwitchInput}
                      disabled={certified || isReadOnly}
                      label="Free Form Address"
                      name="addrFreeForm"
                    />
                    <Field
                      component={SwitchInput}
                      disabled={certified || isReadOnly}
                      label="International Address"
                      name="addrInternational"
                    />
                  </div>
                  {formValues &&
                  formValues.getIn(['values', 'addrFreeForm']) ? (
                    <FieldColumn padding="0px" width="100%">
                      <Field
                        component={TextInput}
                        disabled={certified || isReadOnly}
                        label="Line 1"
                        name="addrFreeForm1"
                        placeholder="Line 1"
                        type="text"
                      />
                      <Field
                        component={TextInput}
                        disabled={certified || isReadOnly}
                        label="Line 2"
                        name="addrFreeForm2"
                        placeholder="Line 2"
                        type="text"
                      />
                      <Field
                        component={TextInput}
                        disabled={certified || isReadOnly}
                        label="Line 3"
                        name="addrFreeForm3"
                        placeholder="Line 3"
                        type="text"
                      />
                    </FieldColumn>
                  ) : (
                    <Fragment>
                      <Field
                        component={TextInput}
                        disabled={certified || isReadOnly}
                        label="Suite/Apt"
                        name="addrUnitDesignator"
                        placeholder="Suite/Apt"
                        type="text"
                      />
                      <Field
                        component={TextInput}
                        disabled={certified || isReadOnly}
                        label="Delivery Address"
                        name="addrDeliveryLine"
                        placeholder="Delivery Address"
                        type="text"
                      />
                      <div style={{ display: 'flex' }}>
                        <FieldColumn padding="0px 20px 0px 0px" width="50%">
                          <Field
                            component={TextInput}
                            disabled={certified || isReadOnly}
                            label="City/Township"
                            name="addrCity"
                            placeholder="City/Township"
                            type="text"
                          />
                        </FieldColumn>
                        <FieldColumn padding="0px 20px 0px 0px" width="25%">
                          <Field
                            component={TextInput}
                            disabled={certified || isReadOnly}
                            label="State/Province/Region"
                            name="addrState"
                            placeholder="State/Province/Region"
                            type="text"
                          />
                        </FieldColumn>
                        <FieldColumn padding="0px" width="25%">
                          <Field
                            component={TextInput}
                            disabled={certified || isReadOnly}
                            label="Zip"
                            name="addrZip"
                            placeholder="Zip"
                            type="text"
                          />
                        </FieldColumn>
                      </div>
                      <div style={{ display: 'flex' }}>
                        <FieldColumn padding="0px 20px 0px 0px" width="50%">
                          <Field
                            component={DropdownInput}
                            disabled={isReadOnly}
                            handleLarge
                            label="Country"
                            name="addrCountry"
                            options={(
                              (dropdowns && dropdowns.get('data')
                                ? dropdowns.get('data').toJS().addrCountry
                                : []) || []
                            ).map((item) => ({
                              value: item.codeName,
                              label: `(${item.codeName}) - ${item.codeDescription}`,
                            }))}
                            normalize={(value) => value.value}
                          />
                        </FieldColumn>
                      </div>
                    </Fragment>
                  )}
                </FieldColumn>
                <FieldColumn padding="0px 20px 0px 20px" width="50%">
                  <PhoneNumbers
                    property={property}
                    isNew={isNew}
                    ownerId={ownerId}
                    viewOnly={viewOnly}
                  />
                </FieldColumn>
              </SubjectDetailFormContainer>
              <SubjectDetailFormContainer wrap="wrap">
                <InfoBlock>
                  <FormGroupTitleContainer>
                    <FormGroupTitle>ELECTRONIC INFORMATION</FormGroupTitle>
                  </FormGroupTitleContainer>
                  <div className="flex-container confidential-container">
                    <div className="flex-container switch-container">
                      Confidential Flag
                      <Field
                        component={SwitchInput}
                        disabled={certified || isReadOnly}
                        label=" "
                        name="confidential"
                      />
                    </div>
                  </div>
                  <div>
                    <Field
                      component={TextInput}
                      disabled={certified || isReadOnly}
                      label="Confidential Name"
                      name="confidentialName"
                      placeholder="Confidential Name"
                      style={{ width: '100%' }}
                      type="text"
                    />
                  </div>
                  <div className="flex-container switch-container">
                    Web Suppression
                    <Field
                      component={SwitchInput}
                      disabled={certified || isReadOnly}
                      label=" "
                      name="webSuppression"
                    />
                  </div>
                  <Field
                    component={TextInput}
                    disabled={certified || isReadOnly}
                    label="Email Address"
                    name="emailAddress"
                    placeholder="Email Address"
                    type="text"
                  />
                  <Field
                    component={TextInput}
                    disabled={certified || isReadOnly}
                    label="Web URL"
                    name="webURL"
                    placeholder="Web URL"
                    type="text"
                  />
                  <Field
                    component={TextInput}
                    disabled={certified || isReadOnly}
                    label="FTP Address"
                    name="ftpAddress"
                    placeholder="FTP Address"
                    type="text"
                  />
                </InfoBlock>
                <InfoBlock width="calc(67% - 40px)">
                  <FormGroupTitleContainer>
                    <FormGroupTitle>SENSITIVE INFORMATION</FormGroupTitle>
                  </FormGroupTitleContainer>
                  <OwnerDetail.SubBlockWrapper>
                    <OwnerDetail.SubBlockContainer>
                      <h5>OWNER</h5>
                      <div>
                        <Field
                          component={TextInput}
                          disabled={certified || isReadOnly}
                          label="Drivers License"
                          name="driversLicense"
                          placeholder="Drivers License"
                          type="text"
                        />
                        <Field
                          component={TextInput}
                          disabled={certified || isReadOnly}
                          label="State"
                          name="driversLicenseState"
                          placeholder="State"
                          type="text"
                        />
                        <div className="flex-container date-time-wrapper">
                          <span>Expiration Date</span>
                          <CalendarInputContainer>
                            <span>
                              <i className="icon fa-calendar" />
                            </span>
                            <Field
                              className="form-control"
                              disabled={certified || isReadOnly}
                              component="input"
                              max="2999-12-31"
                              name="expirationDt"
                              type="date"
                              format={(value) => {
                                let tempValue = value;
                                if (value && value.match(/T.*$/gi)) {
                                  tempValue = tempValue.replace(/T.*$/gi, '');
                                }
                                return tempValue;
                              }}
                            />
                          </CalendarInputContainer>
                        </div>
                        <div className="flex-container date-time-wrapper">
                          <span>Birth Date</span>
                          <CalendarInputContainer>
                            <span>
                              <i className="icon fa-calendar" />
                            </span>
                            <Field
                              className="form-control"
                              component="input"
                              disabled={certified || isReadOnly}
                              max="2999-12-31"
                              name="birthDt"
                              type="date"
                              format={(value) => {
                                let tempValue = value;
                                if (value && value.match(/T.*$/gi)) {
                                  tempValue = tempValue.replace(/T.*$/gi, '');
                                }
                                return tempValue;
                              }}
                            />
                          </CalendarInputContainer>
                        </div>
                      </div>
                    </OwnerDetail.SubBlockContainer>
                    <OwnerDetail.SubBlockContainer>
                      <h5>SPOUSE</h5>
                      <div>
                        <Field
                          component={TextInput}
                          disabled={certified || isReadOnly}
                          label="Spouse First Name"
                          name="spouseFirstName"
                          placeholder="Spouse First Name"
                          type="text"
                        />
                        <Field
                          component={TextInput}
                          disabled={certified || isReadOnly}
                          label="Spouse Last Name"
                          name="spouseLastName"
                          placeholder="Spouse Last Name"
                          type="text"
                        />
                        <Field
                          component={TextInput}
                          disabled={certified || isReadOnly}
                          label="Spouse Drivers License"
                          name="spouseDriversLicense"
                          placeholder="Spouse Drivers License"
                          type="text"
                        />
                        <Field
                          component={TextInput}
                          disabled={certified || isReadOnly}
                          label="State"
                          name="spouseDriversLicenseState"
                          placeholder="State"
                          type="text"
                        />
                        <div className="flex-container date-time-wrapper">
                          <span>Expiration Date</span>
                          <CalendarInputContainer>
                            <span>
                              <i className="icon fa-calendar" />
                            </span>
                            <Field
                              className="form-control"
                              disabled={certified || isReadOnly}
                              component="input"
                              max="2999-12-31"
                              name="spouseExpirationDt"
                              type="date"
                              format={(value) => {
                                let tempValue = value;
                                if (value && value.match(/T.*$/gi)) {
                                  tempValue = tempValue.replace(/T.*$/gi, '');
                                }
                                return tempValue;
                              }}
                            />
                          </CalendarInputContainer>
                        </div>
                        <div className="flex-container date-time-wrapper">
                          <span>Birth Date</span>
                          <CalendarInputContainer>
                            <span>
                              <i className="icon fa-calendar" />
                            </span>
                            <Field
                              className="form-control"
                              component="input"
                              disabled={certified || isReadOnly}
                              max="2999-12-31"
                              name="spouseBirthDt"
                              type="date"
                              format={(value) => {
                                let tempValue = value;
                                if (value && value.match(/T.*$/gi)) {
                                  tempValue = tempValue.replace(/T.*$/gi, '');
                                }
                                return tempValue;
                              }}
                            />
                          </CalendarInputContainer>
                        </div>
                      </div>
                    </OwnerDetail.SubBlockContainer>
                  </OwnerDetail.SubBlockWrapper>
                </InfoBlock>
                <InfoBlock width="calc(100% - 20px)">
                  <FormGroupTitleContainer>
                    <FormGroupTitle>CASS FOR USPS</FormGroupTitle>
                  </FormGroupTitleContainer>
                  <div>
                    <div className="flex-container switch-container">
                      Auto Validate
                      <Field
                        component={SwitchInput}
                        disabled={certified || isReadOnly || viewOnly}
                        label=" "
                        name="autoCass"
                      />
                    </div>
                    {!isNew && (
                      <p>
                        CASS Address Validated on:{' '}
                        <span>{owner.getIn(['data', 'cassValidationDt'])}</span>
                      </p>
                    )}
                  </div>
                </InfoBlock>
              </SubjectDetailFormContainer>
              <OwnerDetail.FlexContainer>
                <OwnerDetail.LabelContainer>
                  <label>Legacy Owner ID:</label>
                  <p>{owner.getIn(['data', 'legacyOwnerID'])}</p>
                </OwnerDetail.LabelContainer>
                <OwnerDetail.ButtonContainer>
                  <StyledButton
                    disabled={
                      owner.get('state') === fetchingState.SAVING ||
                      !isEditable ||
                      certified ||
                      isReadOnly
                    }
                    onClick={() => {
                      const formData = this.props.formValues
                        .get('values')
                        .toJS();
                      if (formData.autoCass) {
                        this.validate();
                      } else {
                        this.onSave();
                      }
                    }}
                  >
                    Save
                  </StyledButton>
                </OwnerDetail.ButtonContainer>
              </OwnerDetail.FlexContainer>
              {!isNew && (
                <SubjectComments
                  addNote={
                    isEditable && !certified && !isReadOnly
                      ? addOwnerNote
                      : null
                  }
                  deleteNote={
                    isEditable && !certified && !isReadOnly
                      ? deleteOwnerNote
                      : null
                  }
                  disabled={certified || isReadOnly}
                  notes={notes}
                  subjectId={ownerId}
                  subjectType={'Owner'}
                  updateNote={
                    isEditable && !certified && !isReadOnly
                      ? updateOwnerNote
                      : null
                  }
                />
              )}
              {!isNew && (
                <SubjectProperties
                  addNote={addOwnerNote}
                  deleteNote={deleteOwnerNote}
                  history={history}
                  properties={properties}
                  subjectId={ownerId}
                  subjectType={'Owner'}
                  updateNote={updateOwnerNote}
                />
              )}
              {!isNew && (
                <OwnerGroup
                  disabled={!isEditable || certified || isReadOnly}
                  addOwnerGroup={(data) => this.onAddOwnerGroup(data)}
                  deleteOwnerGroup={(data) => this.onDeleteOwnerGroup(data)}
                  setPrimaryOwnerGroup={(data) =>
                    this.onSetPrimaryOwnerGroup(data)
                  }
                  ownerGroups={ownerGroups}
                  openOwnerLookupModal={() => this.onOpenOwnerModal()}
                  resetOwnerModalSelection={resetOwnerModalSelection}
                  selectedOwner={selectedOwner}
                />
              )}
            </Fragment>
          )}
        </TabPanel>
        <TabPanel value={value} index={1}>
          {!isNew && <OwnerEvents ownerID={+ownerId} isReadOnly={isReadOnly} />}
        </TabPanel>
        <TabPanel value={value} index={2}>
          {!isNew && <OwnerRevisionHistory ownerID={+ownerId} />}
        </TabPanel>
        <TabPanel value={value} index={3}>
          {!isNew && <OwnerTags ownerID={+ownerId} isReadOnly={isReadOnly} />}
        </TabPanel>
        <TabPanel value={value} index={4}>
          {!isNew && (
            <OwnerAliasNames ownerID={+ownerId} isReadOnly={isReadOnly} />
          )}
        </TabPanel>
        <Dialog
          className={'ownerDetailAddressConfirmDialog'}
          open={this.state.addressConfirmDialogOpen}
          onClose={() => {
            this.setState({ addressConfirmDialogOpen: false });
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xl"
          classes={{
            paper: this.props.classes.rootStyle,
          }}
        >
          <div
            style={{ width: '650px', height: '200px', position: 'relative' }}
          >
            <div style={{ top: '5px', right: '10px', position: 'absolute' }}>
              <IconButton
                style={{ margin: 0, padding: 0 }}
                onClick={() => {
                  this.setState({ addressConfirmDialogOpen: false });
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
            <div style={{ padding: '20px 20px 0px 20px' }}>
              <div
                style={{
                  fontFamily: 'Roboto',
                  fontSize: '21px',
                  fontWeight: 500,
                }}
              >
                Address Correction Confirmation
              </div>
              <div style={{ display: 'flex', padding: '20px 0 0 0' }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    borderRight: '1px solid black',
                    padding: '0 80px 0 0',
                  }}
                >
                  <div style={{ fontWeight: 600, padding: '0px 0px 0px 0px' }}>
                    CURRENT ADDRESS
                  </div>
                  <div style={{ color: '#35449d', lineHeight: 1.17 }}>
                    {formValues &&
                    formValues.get('values') &&
                    formValues.get('values').toJS()
                      ? formValues.get('values').toJS().addrDeliveryLine
                      : ''}
                  </div>
                  <div style={{ color: '#35449d', lineHeight: 1.17 }}>
                    {formValues &&
                    formValues.get('values') &&
                    formValues.get('values').toJS()
                      ? `${formValues.get('values').toJS().addrCity} ${
                          formValues.get('values').toJS().addrState
                        }, ${formValues.get('values').toJS().addrZip}`
                      : ''}
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '0 0 0 80px',
                  }}
                >
                  <div style={{ fontWeight: 600, padding: '0px 0px 5px px' }}>
                    CORRECTED ADDRESS
                  </div>
                  <div style={{ color: '#35449d', lineHeight: 1.17 }}>
                    {this.props.ownerValidate &&
                    this.props.ownerValidate.toJS() &&
                    this.props.ownerValidate.toJS().data
                      ? this.props.ownerValidate.toJS().data.addrDeliveryLine
                      : ''}
                  </div>
                  <div style={{ color: '#35449d', lineHeight: 1.17 }}>
                    {this.props.ownerValidate &&
                    this.props.ownerValidate.toJS() &&
                    this.props.ownerValidate.toJS().data
                      ? `${this.props.ownerValidate.toJS().data.addrCity} ${
                          this.props.ownerValidate.toJS().data.addrState
                        }, ${this.props.ownerValidate.toJS().data.addrZip}`
                      : ''}
                  </div>
                </div>
                <div></div>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  padding: '20px 0 0 0',
                }}
              >
                <Button
                  style={{
                    color: '#35449d',
                    fontWeight: 500,
                    fontSize: '15px',
                  }}
                  onClick={() => {
                    this.onSave();
                    this.setState({ addressConfirmDialogOpen: false });
                  }}
                >
                  Approve
                </Button>
                <Button
                  style={{
                    color: '#dc004e',
                    fontWeight: 500,
                    fontSize: '15px',
                  }}
                  onClick={() => {
                    this.onDecline();
                    this.setState({ addressConfirmDialogOpen: false });
                  }}
                >
                  Decline
                </Button>
              </div>
            </div>
          </div>
        </Dialog>
      </Container>
    );
  }
}

OwnerDetail.SubBlockWrapper = styled.div`
  display: flex;
`;

OwnerDetail.SubBlockContainer = styled.div`
  width: 50%;
  padding: 10px;
  border: 1px solid #ccc;

  &:first-child {
    margin-right: 20px;
  }

  > h5 {
    font-size: 16px;
    font-weight: 500;
  }
`;

OwnerDetail.FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

OwnerDetail.LabelContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 20px;

  > label {
    margin-bottom: 0;
    margin-right: 10px;
  }

  > p {
    margin-bottom: 0;
    color: #303f9f;
    font-weight: 600;
  }
`;

OwnerDetail.ButtonContainer = styled.div`
  padding: 20px 10px;
  text-align: right;
`;

const mapDispatchToProps = {
  addOwnerNote: ownerActions.addOwnerNote,
  deleteOwnerNote: ownerActions.deleteOwnerNote,
  fetchOwner: ownerActions.fetchOwner,
  fetchOwnerNotes: ownerActions.fetchOwnerNotes,
  fetchOwnerProperties: ownerActions.fetchOwnerProperties,
  fetchPropertyDropdowns: propertyActions.fetchPropertyDropdowns,
  resetOwnerData: ownerActions.resetOwnerData,
  validateOwner: ownerActions.validateOwner,
  validateOwnerAddress: ownerActions.validateOwnerAddress,

  updateOwner: ownerActions.updateOwner,
  createOwner: ownerActions.createOwner,
  showSuccess: showSuccess,
  showError: showError,
  updateOwnerNote: ownerActions.updateOwnerNote,
  fetchOwnerGroups: ownerActions.fetchOwnerGroups,
  addOrCreateOwnerGroup: ownerActions.addOrCreateOwnerGroup,
  deleteOwnerGroup: ownerActions.deleteOwnerGroup,
  openOwnerLookupModal: ownerActions.openOwnerLookupModal,
  resetOwnerModalSelection: ownerActions.ownerLookupModalSelectRecords,
  setPrimaryOwnerGroup: ownerActions.setPrimaryOwnerGroup,
  resetOwnerGroups: ownerActions.resetOwnerGroups,
  fetchPropertyOwners: propertyActions.fetchPropertyOwners,
  fetchPropertyOwnerNames: propertyActions.fetchPropertyOwnerNames,
};

const enhance = compose(
  withStyles(styles),
  withRouter,
  connect(selector, mapDispatchToProps),
  reduxForm({
    form: 'appraisalOwnerDetail',
    destroyOnUnmount: true,
    initialValues: {
      autoCass: true,
    },
  }),
);

export default enhance(OwnerDetail);
